/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const WebChatDemo = ({
                         headerText,
                         headerBackground,
                         bodyBackground,
                         botMessageBackground,
                         userMessageBackground,
                         footerBackground,
                         userTextColor,
                         botTextColor,
                         quickReplyTextColor,
                     }) => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 432.51 342.25"
        style={{enableBackground: 'new 0 0 432.51 342.25'}}
        xmlSpace="preserve"
    >
        <g id="Group_340" transform="translate(-668 -677)">
            <g transform="matrix(1, 0, 0, 1, 668, 677)">
                <rect id="Rectangle_1328-2" x="0.13" y="0.13" fill={bodyBackground} stroke="#D3D3D3" strokeWidth="0.25"
                      strokeMiterlimit="10" width="211" height="342"/>
            </g>
            <g transform="matrix(1, 0, 0, 1, 668, 677)">
                <rect id="Rectangle_1329-2" x="0.13" y="0.13" fill={'#FFFFFF'} width="211" height="26.38"/>
            </g>
            <text transform="matrix(1 0 0 1 678.675 691.51)" fill={headerBackground}
                  style={{fontSize: '9px', fontWeight: '800'}}>
                  Virtual Assistant
            </text>
            <rect id="Rectangle_1330" x="852.75" y="677.13" fill={'#FFFFFF'} width="26.38" height="26.38"/>
            <g id="Group_336" transform="translate(685.55 753.444)">
                <path
                    id="Path_1708"
                    fill={headerBackground}
                    d="M-2.99,1.29c-0.39,0-0.7,0.31-0.7,0.7v2.61c0,0.39,0.31,0.7,0.7,0.7h0.52V1.96
			c0-0.21,0.02-0.42,0.05-0.63c-0.01-0.01-0.02-0.03-0.03-0.03H-2.99z"
                />
                <path
                    id="Path_1709"
                    fill={headerBackground}
                    d="M5.95-2.98c0.24,0,0.43-0.19,0.43-0.43c0-0.24-0.19-0.43-0.43-0.43
			c-0.24,0-0.43,0.19-0.43,0.43C5.52-3.17,5.72-2.98,5.95-2.98z"
                />
                <path
                    id="Path_1710"
                    fill={headerBackground}
                    d="M-1.77-2.98c0.24,0,0.43-0.19,0.43-0.43c0-0.24-0.19-0.43-0.43-0.43
			c-0.24,0-0.43,0.19-0.43,0.43C-2.2-3.17-2.01-2.98-1.77-2.98z"
                />
                <path
                    id="Path_1711"
                    fill={headerBackground}
                    d="M2.09-6.88c-4.95,0-8.97,4.02-8.97,8.97s4.02,8.97,8.97,8.97c4.95,0,8.97-4.02,8.97-8.97
			C11.06-2.86,7.05-6.87,2.09-6.88C2.09-6.88,2.09-6.88,2.09-6.88z M8.33,4.54c0,0.66-0.54,1.2-1.2,1.2c0,0-0.01,0-0.01,0H6.67
			c-0.1,1.5-1.35,2.67-2.86,2.67h-3.4c-1.51,0-2.76-1.17-2.86-2.67h-0.48c-0.66,0-1.2-0.53-1.21-1.19c0,0,0-0.01,0-0.01V2.06
			c0-0.61,0.46-1.12,1.06-1.19C-2.92,0-2.53-0.81-1.94-1.47V-2.6c-0.45-0.09-0.74-0.53-0.66-0.98c0.09-0.45,0.53-0.74,0.98-0.66
			c0.45,0.09,0.74,0.53,0.66,0.98c-0.06,0.32-0.31,0.57-0.62,0.65v0.78c0.93-0.85,2.14-1.33,3.4-1.32h0.55
			c1.27,0,2.49,0.48,3.42,1.35v-0.8C5.34-2.69,5.05-3.13,5.13-3.58c0.09-0.45,0.53-0.74,0.98-0.66c0.45,0.09,0.74,0.53,0.66,0.98
			C6.7-2.94,6.46-2.69,6.14-2.61v1.17c0.58,0.65,0.97,1.45,1.13,2.31c0.6,0.07,1.05,0.58,1.06,1.19L8.33,4.54L8.33,4.54z"
                />
                <path
                    id="Path_1712"
                    fill={headerBackground}
                    d="M7.18,1.29H6.64c-0.01,0-0.01,0-0.01,0c0.03,0.22,0.05,0.44,0.05,0.66v2.29l0,0v1.06h0.49
			c0.39,0,0.7-0.31,0.7-0.7V2C7.88,1.61,7.57,1.3,7.18,1.29C7.18,1.29,7.18,1.29,7.18,1.29z"
                />
                <path
                    id="Path_1713"
                    fill={headerBackground}
                    d="M0.15,2.92c-0.2,0-0.37,0.16-0.37,0.36c0,0.2,0.16,0.37,0.36,0.37c0.2,0,0.37-0.16,0.37-0.36
			c0,0,0,0,0,0C0.52,3.09,0.35,2.92,0.15,2.92L0.15,2.92z"
                />
                <path
                    id="Path_1714"
                    fill={headerBackground}
                    d="M4.18,2.92c-0.2,0-0.37,0.16-0.37,0.36c0,0.2,0.16,0.37,0.36,0.37c0.2,0,0.37-0.16,0.37-0.36
			c0,0,0,0,0,0C4.55,3.09,4.38,2.92,4.18,2.92z"
                />
                <path
                    id="Path_1715"
                    fill={headerBackground}
                    d="M4.21,1.34H0.12c-0.8,0-1.44,0.65-1.44,1.44c0,0,0,0,0,0V3.7c0,0.8,0.64,1.44,1.44,1.44
			c0,0,0,0,0,0h4.09c0.79,0,1.44-0.65,1.44-1.44V2.79C5.65,1.99,5.01,1.35,4.21,1.34C4.21,1.34,4.21,1.34,4.21,1.34z M0.16,3.94
			c-0.36,0-0.65-0.29-0.65-0.65c0-0.36,0.29-0.65,0.65-0.65c0.36,0,0.65,0.29,0.65,0.65C0.81,3.65,0.52,3.94,0.16,3.94
			C0.16,3.94,0.16,3.94,0.16,3.94L0.16,3.94z M4.18,3.94c-0.36,0-0.65-0.29-0.65-0.65c0-0.36,0.29-0.65,0.65-0.65
			c0.36,0,0.65,0.29,0.65,0.65c0,0,0,0,0,0C4.83,3.65,4.54,3.94,4.18,3.94L4.18,3.94z"
                />
                <path
                    id="Path_1716"
                    fill={headerBackground}
                    d="M0.19,5.75c-0.13,0-0.24,0.07-0.3,0.18C-1.03,5.81-1.9,5.41-2.6,4.8l-0.22,0.23
			c0.75,0.66,1.69,1.08,2.68,1.21c0.08,0.18,0.29,0.26,0.46,0.18s0.26-0.29,0.18-0.46C0.46,5.83,0.33,5.75,0.19,5.75L0.19,5.75z"
                />
                <path
                    id="Path_1717"
                    fill={headerBackground}
                    d="M2.73,6h-1.3C1.35,6,1.29,6.07,1.29,6.14v0.07c0,0.38,0.3,0.7,0.68,0.71h0.22
			c0.38-0.01,0.68-0.33,0.68-0.71V6.14C2.87,6.06,2.8,6,2.73,6z"
                />
                <path
                    id="Path_1718"
                    fill={headerBackground}
                    d="M2.37-2.58H1.82c-2.1,0-3.95,1.4-4.5,3.43h0.44C-1.66-0.96,0.03-2.2,1.93-2.2h0.34
			c1.91,0,3.59,1.24,4.18,3.05h0.42C6.32-1.18,4.47-2.59,2.37-2.58z"
                />
            </g>
            <g id="Group_337" transform="translate(685.55 842.354)">
                <path
                    id="Path_1708-2"
                    fill={headerBackground}
                    d="M-2.99,1.29c-0.39,0-0.7,0.31-0.7,0.7v2.61c0,0.39,0.31,0.7,0.7,0.7h0.52V1.96
			c0-0.21,0.02-0.42,0.05-0.63c-0.01-0.01-0.02-0.03-0.03-0.03H-2.99z"
                />
                <path
                    id="Path_1709-2"
                    fill={headerBackground}
                    d="M5.95-2.98c0.24,0,0.43-0.19,0.43-0.43c0-0.24-0.19-0.43-0.43-0.43
			c-0.24,0-0.43,0.19-0.43,0.43C5.52-3.17,5.72-2.98,5.95-2.98z"
                />
                <path
                    id="Path_1710-2"
                    fill={headerBackground}
                    d="M-1.77-2.98c0.24,0,0.43-0.19,0.43-0.43c0-0.24-0.19-0.43-0.43-0.43
			c-0.24,0-0.43,0.19-0.43,0.43C-2.2-3.17-2.01-2.98-1.77-2.98z"
                />
                <path
                    id="Path_1711-2"
                    fill={headerBackground}
                    d="M2.09-6.88c-4.95,0-8.97,4.02-8.97,8.97s4.02,8.97,8.97,8.97c4.95,0,8.97-4.02,8.97-8.97
			C11.06-2.86,7.05-6.87,2.09-6.88C2.09-6.88,2.09-6.88,2.09-6.88z M8.33,4.54c0,0.66-0.54,1.2-1.2,1.2c0,0-0.01,0-0.01,0H6.67
			c-0.1,1.5-1.35,2.67-2.86,2.67h-3.4c-1.51,0-2.76-1.17-2.86-2.67h-0.48c-0.66,0-1.2-0.53-1.21-1.19c0,0,0-0.01,0-0.01V2.06
			c0-0.61,0.46-1.12,1.06-1.19C-2.92,0-2.53-0.81-1.94-1.47V-2.6c-0.45-0.09-0.74-0.53-0.66-0.98c0.09-0.45,0.53-0.74,0.98-0.66
			c0.45,0.09,0.74,0.53,0.66,0.98c-0.06,0.32-0.31,0.57-0.62,0.65v0.78c0.93-0.85,2.14-1.33,3.4-1.32h0.55
			c1.27,0,2.49,0.48,3.42,1.35v-0.8C5.34-2.69,5.05-3.13,5.13-3.58c0.09-0.45,0.53-0.74,0.98-0.66c0.45,0.09,0.74,0.53,0.66,0.98
			C6.7-2.94,6.46-2.69,6.14-2.61v1.17c0.58,0.65,0.97,1.45,1.13,2.31c0.6,0.07,1.05,0.58,1.06,1.19L8.33,4.54L8.33,4.54z"
                />
                <path
                    id="Path_1712-2"
                    fill={headerBackground}
                    d="M7.18,1.29H6.64c-0.01,0-0.01,0-0.01,0c0.03,0.22,0.05,0.44,0.05,0.66v2.29l0,0v1.06h0.49
			c0.39,0,0.7-0.31,0.7-0.7V2C7.88,1.61,7.57,1.3,7.18,1.29C7.18,1.29,7.18,1.29,7.18,1.29z"
                />
                <path
                    id="Path_1713-2"
                    fill={headerBackground}
                    d="M0.15,2.92c-0.2,0-0.37,0.16-0.37,0.36c0,0.2,0.16,0.37,0.36,0.37
			c0.2,0,0.37-0.16,0.37-0.36c0,0,0,0,0,0C0.52,3.09,0.35,2.92,0.15,2.92L0.15,2.92z"
                />
                <path
                    id="Path_1714-2"
                    fill={headerBackground}
                    d="M4.18,2.92c-0.2,0-0.37,0.16-0.37,0.36c0,0.2,0.16,0.37,0.36,0.37
			c0.2,0,0.37-0.16,0.37-0.36c0,0,0,0,0,0C4.55,3.09,4.38,2.92,4.18,2.92z"
                />
                <path
                    id="Path_1715-2"
                    fill={headerBackground}
                    d="M4.21,1.34H0.12c-0.8,0-1.44,0.65-1.44,1.44c0,0,0,0,0,0V3.7c0,0.8,0.64,1.44,1.44,1.44
			c0,0,0,0,0,0h4.09c0.79,0,1.44-0.65,1.44-1.44V2.79C5.65,1.99,5.01,1.35,4.21,1.34C4.21,1.34,4.21,1.34,4.21,1.34z M0.16,3.94
			c-0.36,0-0.65-0.29-0.65-0.65c0-0.36,0.29-0.65,0.65-0.65c0.36,0,0.65,0.29,0.65,0.65C0.81,3.65,0.52,3.94,0.16,3.94
			C0.16,3.94,0.16,3.94,0.16,3.94L0.16,3.94z M4.18,3.94c-0.36,0-0.65-0.29-0.65-0.65c0-0.36,0.29-0.65,0.65-0.65
			c0.36,0,0.65,0.29,0.65,0.65c0,0,0,0,0,0C4.83,3.65,4.54,3.94,4.18,3.94L4.18,3.94z"
                />
                <path
                    id="Path_1716-2"
                    fill={headerBackground}
                    d="M0.19,5.75c-0.13,0-0.24,0.07-0.3,0.18C-1.03,5.81-1.9,5.41-2.6,4.8l-0.22,0.23
			c0.75,0.66,1.69,1.08,2.68,1.21c0.08,0.18,0.29,0.26,0.46,0.18s0.26-0.29,0.18-0.46C0.46,5.83,0.33,5.75,0.19,5.75L0.19,5.75z"
                />
                <path
                    id="Path_1717-2"
                    fill={headerBackground}
                    d="M2.73,6h-1.3C1.35,6,1.29,6.07,1.29,6.14v0.07c0,0.38,0.3,0.7,0.68,0.71h0.22
			c0.38-0.01,0.68-0.33,0.68-0.71V6.14C2.87,6.06,2.8,6,2.73,6z"
                />
                <path
                    id="Path_1718-2"
                    fill={headerBackground}
                    d="M2.37-2.58H1.82c-2.1,0-3.95,1.4-4.5,3.43h0.44C-1.66-0.96,0.03-2.2,1.93-2.2h0.34
			c1.91,0,3.59,1.24,4.18,3.05h0.42C6.32-1.18,4.47-2.59,2.37-2.58z"
                />
            </g>
            <path
                id="Path_2822"
                fill={botMessageBackground}
                d="M701.89,746.56h140.84c5.83,0,10.55,4.72,10.55,10.55c0,0,0,0,0,0v10.55
		c0,5.83-4.72,10.55-10.55,10.55l0,0H712.43c-5.83,0-10.55-4.72-10.55-10.55c0,0,0,0,0,0V746.56z"
            />
            <path
                id="Path_2823"
                fill={botMessageBackground}
                d="M701.89,835.46h140.84c5.83,0,10.55,4.72,10.55,10.55c0,0,0,0,0,0v10.55
		c0,5.83-4.72,10.55-10.55,10.55l0,0H712.43c-5.83,0-10.55-4.72-10.55-10.55c0,0,0,0,0,0V835.46z"
            />
            <path
                id="Path_2824"
                fill={userMessageBackground}
                d="M868.58,817.12h-66.99c-5.83,0-10.55-4.72-10.55-10.55c0,0,0,0,0,0v0.53
		c0-5.83,4.72-10.55,10.55-10.55l0,0h56.44c5.83,0,10.55,4.72,10.55,10.55V817.12z"
            />
            <text transform="matrix(1 0 0 1 707.16 760.828)" style={{fontSize: '8px'}} fill={botTextColor}>
                Lorem ipsum dolor sit amet dolores
                {' '}
            </text>
            <text transform="matrix(1 0 0 1 707.16 770.828)" style={{fontSize: '8px'}} fill={botTextColor}>
                molores ipsum dolor sit amet
            </text>
            <text transform="matrix(1 0 0 1 707.16 849.736)" style={{fontSize: '8px'}} fill={botTextColor}>
                Lorem ipsum dolor sit amet dolores
                {' '}
            </text>
            <text transform="matrix(1 0 0 1 707.16 859.736)" style={{fontSize: '8px'}} fill={botTextColor}>
                molores ipsum dolor sit amet
            </text>
            <text transform="matrix(1 0 0 1 707.394 787.354)" style={{fontSize: '5px'}} fill="#A5A5A5">
                10:08
            </text>
            <text transform="matrix(1 0 0 1 702.119 876.272)" style={{fontSize: '5px'}} fill="#A5A5A5">
                10:08
            </text>
            <text transform="matrix(1 0 0 1 852.456 826.288)" style={{fontSize: '5px'}} fill="#A5A5A5">
                10:08
            </text>
            <text transform="matrix(1 0 0 1 801.583 807.819)" style={{fontSize: '5px'}} fill={userTextColor}>
                Shopping on youx
            </text>
            <g id="Group_338" transform="translate(874.183 704.36) rotate(180)">
                <circle id="Ellipse_224" fill="#FFFFFF" cx="8.19" cy="19.38" r="1.32"/>
                <circle id="Ellipse_225" fill="#FFFFFF" cx="8.19" cy="13.78" r="1.32"/>
                <circle id="Ellipse_226" fill="#FFFFFF" cx="8.19" cy="8.19" r="1.32"/>
            </g>
            <path
                id="Rectangle_1331"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M706.89,885.46h62.27c2.76,0,5,2.24,5,5v5.3c0,2.76-2.24,5-5,5h-62.27
		c-2.76,0-5-2.24-5-5v-5.3C701.89,887.7,704.12,885.46,706.89,885.46z"
            />
            <path
                id="Rectangle_1332"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M780.82,885.46h23.07c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-23.07
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C777.32,887.03,778.89,885.46,780.82,885.46z"
            />
            <path
                id="Rectangle_1333"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M705.39,903.88h80.57c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-80.57
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C701.89,905.44,703.45,903.88,705.39,903.88z"
            />
            <path
                id="Rectangle_1334"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M796.11,903.88h38.89c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-38.89
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C792.61,905.44,794.18,903.88,796.11,903.88z"
            />
            <path
                id="Rectangle_1335"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M705.39,922.29h63.68c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-63.68
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C701.89,923.86,703.45,922.29,705.39,922.29z"
            />
            <path
                id="Rectangle_1336"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M779.23,922.29h76.34c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-76.34
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C775.73,923.86,777.3,922.29,779.23,922.29z"
            />
            <path
                id="Rectangle_1337"
                fill="none"
                stroke={userMessageBackground}
                strokeWidth="0.5"
                d="M705.39,940.7h38.36c1.93,0,3.5,1.57,3.5,3.5v8.3c0,1.93-1.57,3.5-3.5,3.5h-38.36
		c-1.93,0-3.5-1.57-3.5-3.5v-8.3C701.89,942.27,703.45,940.7,705.39,940.7z"
            />
            <text transform="matrix(1 0 0 1 707.16 895.103)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Shopping on youx
            </text>
            <text transform="matrix(1 0 0 1 782.329 895.103)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Fraud
            </text>
            <text transform="matrix(1 0 0 1 706.633 913.517)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Account &amp; Promotions
            </text>
            <text transform="matrix(1 0 0 1 797.89 913.517)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Complaint
            </text>
            <text transform="matrix(1 0 0 1 707.16 931.932)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Orders &amp; Returns
            </text>
            <text transform="matrix(1 0 0 1 778.9 931.932)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Order &amp; Delivery issue
            </text>
            <text transform="matrix(1 0 0 1 707.16 950.347)" style={{fontSize: '6px'}} fill={quickReplyTextColor}>
                Corporate
            </text>
            <g id="Group_339" transform="translate(675 973.25)">
                <path id="Path_1766" fill={footerBackground} d="M-6.88-6.88h211v52.75h-211V-6.88z"/>
                <text transform="matrix(1 0 0 1 3.675 5.4)" fill="#CECED4" style={{fontSize: '7px'}}>
                    Text...
                </text>
                <rect id="Rectangle_550" x="177.75" y="19.5" fill={footerBackground} width="21.1" height="21.1"/>
                <path
                    id="Path_1705"
                    fill="#A4ADC1"
                    d="M194.59,29.68l-12.47-4.87c-0.2-0.08-0.42-0.03-0.57,0.11c-0.14,0.14-0.15,0.36-0.01,0.5
			l4.1,4.63l-4.1,4.63c-0.13,0.14-0.13,0.36,0.01,0.5c0.1,0.1,0.23,0.15,0.37,0.15c0.07,0,0.14-0.01,0.2-0.04l12.47-4.87
			c0.2-0.06,0.32-0.27,0.26-0.47C194.82,29.82,194.72,29.72,194.59,29.68L194.59,29.68z"
                />
                <rect id="Rectangle_551" x="-1.6" y="19.5" fill={footerBackground} width="21.1" height="21.1"/>
                <path
                    id="Path_1706"
                    fill="#A4ADC1"
                    d="M14.22,27.58c0.05-0.54-0.14-1.07-0.51-1.46c-0.83-0.75-2.12-0.68-2.87,0.15
			c-0.01,0.01-0.02,0.02-0.02,0.03l-1.62,1.65l0,0L5.9,31.31c-0.25,0.25-0.4,0.58-0.42,0.93c-0.03,0.34,0.09,0.68,0.33,0.92
			c0.21,0.22,0.51,0.34,0.81,0.34c0.03,0,0.06,0,0.09,0c0.35-0.03,0.67-0.18,0.91-0.43l2.69-2.74c0.1-0.11,0.1-0.27,0-0.38
			c-0.1-0.1-0.26-0.1-0.37,0c0,0,0,0,0,0l-2.69,2.74c-0.15,0.16-0.35,0.26-0.57,0.28c-0.18,0.02-0.37-0.05-0.5-0.18
			C6.05,32.64,5.98,32.46,6,32.27c0.02-0.22,0.11-0.43,0.27-0.58l3.05-3.11l0,0l1.86-1.9c0.54-0.64,1.49-0.72,2.13-0.19
			c0.01,0,0.01,0.01,0.01,0.01c0.26,0.28,0.39,0.66,0.36,1.04c-0.03,0.43-0.22,0.84-0.53,1.15l-2.32,2.36l-2.87,2.92
			c-0.81,0.96-2.24,1.08-3.2,0.27c-0.01-0.01-0.02-0.01-0.02-0.02c-0.4-0.42-0.6-1-0.55-1.58c0.05-0.65,0.33-1.26,0.79-1.71
			l5.59-5.7c0.1-0.11,0.1-0.27,0-0.38c-0.1-0.1-0.26-0.1-0.37,0c0,0,0,0,0,0l-5.59,5.7c-0.55,0.55-0.88,1.28-0.94,2.06
			c-0.06,0.73,0.19,1.46,0.7,1.99c0.47,0.47,1.1,0.73,1.76,0.72c0.84-0.01,1.63-0.36,2.21-0.97l4.61-4.7l0.58-0.59
			C13.93,28.67,14.18,28.14,14.22,27.58z"
                />
                <path id="Path_1767" fill="none" stroke="#A4ADC1" strokeWidth="0.2" d="M3.68,14.23h189.9"/>
            </g>
        </g>
        <line id="Line_310" fill="none" stroke="#A4ADC1" strokeWidth="0.5" x1="156.63" y1="7.13" x2="418.28" y2="7.13"/>
        <line id="Line_313" fill="none" stroke="#A4ADC1" strokeWidth="0.5" x1="206.63" y1="333.13" x2="418.28"
              y2="333.13"/>
        <line id="Line_402" fill="none" stroke="#A4ADC1" strokeWidth="0.5" x1="200.63" y1="285.13" x2="424.63"
              y2="285.13"/>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_375-2" fill={footerBackground} stroke="#D3D3D3" strokeWidth="0.25" strokeMiterlimit="10"
                    cx="425.27" cy="333.63" r="7.5"/>
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_395-2" fill={bodyBackground} stroke="#D3D3D3" strokeWidth="0.25" strokeMiterlimit="10"
                    cx="425.08" cy="285.63" r="7.5"/>
        </g>
        <path id="Path_2826" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.28,6.13v26.27H19.13v39.48"/>
        <path id="Path_3015" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.01,129.13H183.45"/>
        <path id="Path_3031" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.01,90.13H147.88"/>
        <path id="Path_3019" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.28,185.88H194.21v-50.22"/>
        <path id="Path_3027" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.28,49.59H177.56v27.54"/>
        <path id="Path_3026" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M425.28,234.3H157.54"/>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_372-2" fill={headerBackground} stroke="#D3D3D3" strokeWidth="0.25" strokeMiterlimit="10"
                    cx="425.27" cy="7.63" r="7.5"/>
        </g>
        <path id="Path_2827" fill="none" stroke="#A4ADC1" strokeWidth="0.5" d="M124.39,208.99v-6.03h300.89v-17.08"/>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_373-2" fill={userMessageBackground} stroke="#D3D3D3" strokeWidth="0.25"
                    strokeMiterlimit="10" cx="425.27" cy="186.63" r="7.5"/>
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_394-2" fill={userTextColor} stroke="#D3D3D3" strokeWidth="0.25" strokeMiterlimit="10"
                    cx="425.01" cy="129.63" r="7.5"/>
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_396-2" fill={botTextColor} stroke="#D3D3D3" strokeWidth="0.25" strokeMiterlimit="10"
                    cx="425.01" cy="89.63" r="7.5"/>
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_376-2" fill={quickReplyTextColor} stroke="#D3D3D3" strokeWidth="0.25"
                    strokeMiterlimit="10" cx="425.08" cy="234.63" r="7.5"/>
        </g>
        <g transform="matrix(1, 0, 0, 1, 0, 0)">
            <circle id="Ellipse_374-2" fill={botMessageBackground} stroke="#D3D3D3" strokeWidth="0.25"
                    strokeMiterlimit="10" cx="425.27" cy="49.63" r="7.5"/>
        </g>
    </svg>
);

WebChatDemo.propTypes = {
    headerBackground: PropTypes.string.isRequired,
    bodyBackground: PropTypes.string.isRequired,
    botMessageBackground: PropTypes.string.isRequired,
    userMessageBackground: PropTypes.string.isRequired,
    footerBackground: PropTypes.string.isRequired,
    botTextColor: PropTypes.string.isRequired,
    userTextColor: PropTypes.string.isRequired,
    quickReplyTextColor: PropTypes.string.isRequired,
};

export default WebChatDemo;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/webchat-conf/WebChatDemo.jsx